import { render } from "./ProkuroriaChips.vue?vue&type=template&id=07a0ecb2&scoped=true"
import script from "./ProkuroriaChips.vue?vue&type=script&lang=js"
export * from "./ProkuroriaChips.vue?vue&type=script&lang=js"

import "./ProkuroriaChips.vue?vue&type=style&index=0&id=07a0ecb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a0ecb2"]])

export default __exports__